import request from '@/utils/request'

const url = '/home/goods/'
const api = {
  getCateGroyMsg (data) {
    return request({
      url: url + 'getCateGroyMsg',
      method: 'post',
      data
    })
  },
  getAttribute (data) {
    return request({
      url: url + 'getAttribute',
      method: 'post',
      data
    })
  },
  category_pc_list (data) {
    return request({
      url: url + 'category_pc_list',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/createGroy.js